import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { pageSpinnerReducer } from './page-spinner.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('spinner', pageSpinnerReducer)],
})
export class PageSpinnerModule {}
